import {
  VConsole,
  axios,
  Stream,
  Bridge,
  toast,
  isAPP,
  isAliMp,
  isMeiTuanMp,
  APIS,
  dom,
  jumpMethods,
  Stat,
  getRequireParams,
  appTrackPageView,
  appTrackEvent,
} from '@/entry/templateCommon';
import '@/scss/section-handler.scss';
import '@/scss/category.scss';
import loading from '@/lib/loading';
import {GetQueryString} from '@/lib/util';
import {getScrollTop, getScrollHeight, setScrollTop} from '@/lib/scrollVariate';
import {defaultMap} from '@/util/categoryMap';
import channelMap from '@/util/channelIdMap.config';
import xinliceshiApp from '@/util/xinliceshiApp'
import share from '@/util/share'

new VConsole();

share({
  title: '专业、有趣、好玩的壹心理测评，用心理学探索未知自己',
  desc: '壹心理测评，点击开始测试',
  link: location.href,
  imgUrl: 'https://ossimg.xinli001.com/20200309/9c00bc9481c1ddf25fddcc94f2f451ae.png'
})

let urlSplit = location.pathname.split('/');
let category = 'ff';
function getCategory() {
  if (/cpapi(\-(qc\d{1}|box\d{1}))?.xinli001.com/.test(location.origin)) {
    // cpapi域名直接取值
    category = urlSplit[urlSplit.length - 1];
  } else if (/m(\-(qc\d{1}|box\d{1}))?.xinli001.com/.test(location.origin)) {
    // m站域名要通过map进行筛选
    category = defaultMap[urlSplit[urlSplit.length - 1]] || 'ff';
  } else if (/cp-wx(\-(qc\d{1}|box\d{1}))?.xinli001.cc/.test(location.origin)) {
    // cp-wx 站域名（美团小程序里面用了微信小程序的UA导致跳到这个域名）要通过map进行筛选
    category = defaultMap[urlSplit[urlSplit.length - 1]] || 'ff';
  }
}
getCategory()
const slice = Array.prototype.slice;
const itemTpl = `<li class="assessment-list__item" data-id="{{id}}" data-type="{{type}}">
            <div class="cf">
                <div class="fl assessment-list__item__left">
                    <a class="assessment-list__item-title color-main text-limit fs-16">{{name}}</a>

                    <div class="fs-12 color-light assessment-list2__item-desc">
                        <p class="text-limit" style="-webkit-box-orient: vertical;">{{shortDescribe}}</p>
                        <div class="assessment-list2__item-info"><span class="fs-14 color-red">{{discountPrice}}</span><span class="fr">{{countDesc}}</span></div>
                    </div>
                </div>

                <div class="fr"><img src="{{listPicture}}" alt="" class="assessment-list__item-img"></div>
            </div>
        </li>`;

let isFunTest = false
function funTestMain() {
  isFunTest = category == 'qw'
  if (isFunTest) {
    $sortName.style.display = 'none'
  } else {
    $sortName.style.display = ''
  }
}
function getColorType(type) {
  const colorS = [{
    bg: '#528FCC',
    graph_bg: '#006ED9',
    text_bg: '#528FCC'
  },
    {
      bg: '#7852CC',
      graph_bg: '#4900E8',
      text_bg: '#7852CC'
    },
    {
      bg: '#C052CC',
      graph_bg: '#B52DC4',
      text_bg: '#C052CC'
    },
    {
      bg: '#E65C5C',
      graph_bg: '#B83232',
      text_bg: '#E65C5C'
    },
    {
      bg: '#CC8672',
      graph_bg: '#FFA78F',
      text_bg: '#CC8672'
    },
    {
      bg: '#E67129',
      graph_bg: '#FFA200',
      text_bg: '#C78800'
    },
    {
      bg: '#E6C35C',
      graph_bg: '#FFC500',
      text_bg: '#FFDD2B'
    }
  ]
  return colorS[type]
}
let initColor = function(index){
  if (index < 7) {
    return getColorType(index)
  }else{
    let setIndex = index%7
    return getColorType(setIndex)
  }
}
let getMonthInit = function (index) {
  const weekS = new Array("Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec");
  var initTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
  var str = ''
  if (index == 0) {
    str = weekS[new Date(initTime).getMonth()];
  }else if(index == 1){
    initTime = initTime - (86400000 * 1)
    str = weekS[new Date(initTime).getMonth()];
  }else{
    initTime = initTime - (86400000 * 2)
    str = weekS[new Date(initTime).getMonth()];
  }
  return str
}
let getDayInit = function (index) {
  var initTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
  var str = ''
  if (index == 0) {
    str = new Date(initTime).getDate();
  }else if(index == 1){
    initTime = initTime - (86400000 * 1)
    str = new Date(initTime).getDate();
  }else{
    initTime = initTime - (86400000 * 2)
    str = new Date(initTime).getDate();
  }
  return str
}
let funTitle = function (data) {
  if (data.name.length > 14) {
    const title = data.name.slice(0, 9)
    return `${title}...`
  }else{
    return data.name
  }
}
let funSubVal = function (value) {
  return value * 10;
}
const funItemTpl = function (data, index) {
  let starVal = funSubVal(data.star)
  let r = `
    <li class="v-touch assessment-list-fun-item" data-id="${data.id}" data-type="${data.type}" >
      <div class="funtestListItem" style="background:${initColor(index).bg}">
        ${index < 3 ? `<div class="funtestListItem-data"">
          <div class="funtestListItem-data_month">${getMonthInit(index)}</div>
          <div class="funtestListItem-data_day">${getDayInit(index)}</div>
        </div>` : ''}
        <div class="cpInfo">
          <div class="cpInfo-text">
            <p class="title fs-16">
              <span class="text">${funTitle(data)}</span>
            </p>
          </div>
          <div class="cpInfo-tis">
            <div class="tis_name">本周热度</div>
            <div class="tis_content">
              <div class="star-box">
                <div class="star-bar">
                  <span class="${starVal - 0 > 5 ? "icon-star--hover" : "icon-star"}" ></span>
                  ${starVal - 10 > 0 ?
                  `<span class="${starVal - 10 > 5 ? "icon-star--hover" : "icon-star"}"></span>` : ""}
                  ${starVal - 20 > 0 ?
                  `<span class="${starVal - 20 > 5 ? "icon-star--hover" : "icon-star"}"></span>` : ""}
                  ${starVal - 30 > 0 ?
                  `<span class="${starVal - 30 > 5 ? "icon-star--hover" : "icon-star"}"></span>` : ""}
                  ${starVal - 40 > 0 ?
                  `<span class="${starVal - 40 > 5 ? "icon-star--hover" : "icon-star"}"></span>` : ""}
                </div>
              </div>
            </div>
          </div>
          <div class="testListItem_bg">
            <img src="${data.listPicture}" alt="">
          </div>
          <img src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/9fa01fb6960e41fc947ce4ca7e2c517a.png" class="testListItem_bg3" alt="">
        </div>
      </div>
    </li>`
  return r
}
function getDataKeySteram (node, tag = 'li', key = 'data-key') {
  console.log('---getDataKeySteram---')
  return Stream.of(dom.closest(node, 'li'))
    .filter(node => {
      return !!node
    })
    .map(node => {
      let key = node.getAttribute('data-key')
      category = key
      funTestMain()
      return key
    })
    .filter(key => !!key);
}

function renderItem (data, index) {
  let item = ''
  if (isFunTest) {
    item = funItemTpl(data, index)
  } else {
    if (data.type === 'free') {
      data.discountPrice = '免费';
      data.originalPrice = '';
    } else {
      data.discountPrice = `${data.discountPrice}元`;
      data.originalPrice = `￥${data.originalPrice}`;
    }
    item = itemTpl.replace(/{{([\s\S]*?)}}/g, function (match, field) {
      return `${data[field]}` || '';
    })
  }
  return item
  // return itemTpl.replace(/{{([\s\S]*?)}}/g, function (match, field) {
  //   return `${data[field]}` || '';
  // })
}

function updateDropdownHeight (height) {
  var $dropdown = $sectionHandlerDropdown;

  if ($dropdown) {
    $dropdown.style.height = arguments.length ? height : getScrollHeight() - $dropdown.getBoundingClientRect().top - getScrollTop() + 'px';
  }
}

function resetDropdownHeight () {
  updateDropdownHeight('')
}

var $categoryList = document.querySelector('.category-list__left'),
  $sortList = document.querySelector('#sort-list'),
  $sortName = document.getElementById('sort-name'),
  $assessmentList = document.querySelector('.assessment-list2'),
  $assessmentListData = [],
  pageSize = 20,
  pageNum = 0,
  needLoadMore = false, // 是否需要接口分页
  listLoading = false, // 列表是否loading
  listEnd = false, // 列表是否全部加载完成
  outSideParams = {
    category,
    channelId: GetQueryString('channelId') || 513,
    'pageVo.page': 1,
    sortType: (isAPP ? 'TIME' : 'HITS'),
  },
  $sectionHandlerDropdown = document.querySelector('.section-handler__dropdown'),
  internalBehavior$ = Stream.Subject(),
  category$,
  sort$ = Stream.merge(Stream.fromEvent($sortList, 'click').flattenMap(res => {
    console.log('排序方式切换', res);
    // myTracker.sortSwitch(res.event.target.innerText);
    myTracker.send({
      name: 'v5100_测评-分类列表页-切换排序方式',
      properties: {
        '排序方式': res.event.target.innerText
      }
    });

    let r = getDataKeySteram(res.event.target)
    return r;
  }), internalBehavior$).startWith('1'),
  loadMore$ = Stream.fromEvent(window, 'scroll');

funTestMain()
if (isAPP) {
  category$ = Stream.fromEvent($categoryList, 'click').flattenMap(res => getDataKeySteram(res.event.target)).startWith(category)
  let lias = [...$categoryList.querySelectorAll('.s-tabcell a')]
  lias.forEach(lia => {
    lia.removeAttribute('href')
  })
  document.querySelector('.assessment-welcome').style.display = 'none'
} else {
  category$ = Stream.Subject().flattenMap(res => getDataKeySteram(res.event.target)).startWith(category)
  // 获取第一页数据
  getSortData(outSideParams)
}
let myTracker = new Stat();

function insertLoadingTip () {
  let el = document.createElement('p');
  el.setAttribute('class', 'end loading');
  el.innerText = '正在加载更多';
  let list = document.querySelector('.category-list__right');
  list.appendChild(el);
  return el;
}

let loadingTipEl = insertLoadingTip();
/* 左侧列表和排序面板的active状态 */
category$.addListener({
  next (i) {
    var list = slice.call($categoryList.getElementsByTagName('li'), 0);

    list.forEach(node => {
      if (node.getAttribute('data-key') === i) {
        node.classList.add('active', 'fs-16');
      } else {
        node.classList.remove('active', 'fs-16');
      }
    });
  }
});

sort$.addListener({
  next (i) {
    console.log('---sort$ 点击---', i)
    var list = slice.call($sortList.getElementsByTagName('li'), 0);
    var hover = 'section-handler__dropdown-item--hover';

    list.forEach(node => {
      if (node.getAttribute('data-key') === i) {
        node.classList.add(hover);
        $sortName.getElementsByTagName('span')[0].innerText = node.innerText;
        $sortName.setAttribute('data-key', i);
      } else {
        node.classList.remove(hover);
      }
    });
  }
});
/* 选中付费精选时，不显示只看付费/免费，且更正排序 */
category$
  .distinctUntilChanged(function (val, oldVal) {
    var a = 'ff';
    return val === oldVal || (a !== val && a !== oldVal);
  })
// .withLatestFrom(sort$)
  .addListener({
    next (res) {
      var $li = slice.call($sectionHandlerDropdown.getElementsByTagName('li'), -2);
      // 支付宝小程序全部测评没有 只看付费/免费 这两个选项
      if (res === 'ff' && isAPP) {
      // console.log($li);
        $li.forEach(node => {
          node.style.display = 'none'
        });

        // 更正排序
        if (+res[1] > 2) {
          internalBehavior$.next('1');
        }
      } else {
        $li.forEach(node => {
          node.style.display = ''
        });
      }
      // 目录，分类
      let categoryEl = document.querySelector('.category-list__left li.active');
      let sortName = document.querySelector('#sort-name').innerText;
      myTracker.send({
        name: 'v5100_测评-访问分类页栏目',
        properties: {
          '栏目': categoryEl.innerText,
          '排序方式': sortName
        }
      });
    }
  })

let lastCategory = '';

/* 抽取公共的发送请求的方法  */
function getSortData (params) {
  console.log('------getSortData的params------', params)
  // console.log(params)
  listLoading = true;
  return axios.get(APIS.getSort, {
    params
  }).then((json) => {
    let allLoading = [...document.querySelectorAll('.cp-loading')];
    if (allLoading.length) {
      allLoading.map(item => item.classList.add('cp-loading--close'));
    }
    let {code, data, data: {list = []} = {}, msg} = json.data;
    if (+code === 0) {
      $assessmentListData = list;
      pageNum = pageNum + 1;
      if (data.totalPageCount > 1) {
        needLoadMore = true;
        $assessmentList.innerHTML = $assessmentList.innerHTML + list.map(renderItem).join('');
        if (list.length < pageSize && !listEnd) {
          $assessmentList.innerHTML = $assessmentList.innerHTML + `<p class="end">已全部展示</p>`;
          listEnd = true;
        }
      } else {
        needLoadMore = false;
        if (list.length <= pageSize && !listEnd) {
          $assessmentList.innerHTML = list.map(renderItem).join('') + `<p class="end">已全部展示</p>`;
          listEnd = true;
        } else {
          // 一次load完全部数据，先显示20条
          // console.log(`插入: ${pageSize * (pageNum - 1)}${-(pageSize * pageNum)}`)
          $assessmentList.innerHTML = list.slice(pageSize * (pageNum - 1), (pageSize * pageNum)).map(renderItem).join('');
          listEnd = false;
        }
      }
      // toast('加载成功')
    } else {
      toast('获取数据失败')
    }
    listLoading = false;
  })
}

/* 数据请求的流 */
Stream.combine(category$, sort$)
  .skip(1)
  .map((res) => {
    let params = {
      'category': res[0],
      'channelId': channelMap.list.includes(GetQueryString('channelId') * 1) ? GetQueryString('channelId') : 513
    }
    let dataType = (isAPP ? 'TIME' : 'HITS')
    if (!isNaN(res[1] * 1)) {
      params['pageVo.page'] = res[1];
      params.sortType = $sortName.getAttribute('data-key') || dataType;
    } else if (res[0] !== lastCategory) {
      // console.log('=== !==lastCategory === data-key', $sortName.getAttribute('data-key'))
      params.sortType = $sortName.getAttribute('data-key') || dataType;
      params['pageVo.page'] = 1;
      // 重置显示样式
      var list = slice.call($sortList.getElementsByTagName('li'), 0);
      var hover = 'section-handler__dropdown-item--hover';

      list.forEach(node => {
        if (node.getAttribute('data-key') === params.sortType) {
          node.classList.add(hover);
          $sortName.getElementsByTagName('span')[0].innerText = node.innerText;
          $sortName.setAttribute('data-key', dataType);
        } else {
          node.classList.remove(hover);
        }
      });
    } else {
      params['pageVo.page'] = 1;
      params.sortType = res[1];
    }
    lastCategory = res[0];
    setScrollTop(0);
    loading('正在加载数据', 10000)
    pageNum = 0;
    outSideParams = params;
    $assessmentList.innerHTML = '';

    let $lis = [...$sortList.getElementsByTagName('li')]
    let sortTypeEl = $lis.filter(item => {
      if (item.getAttribute('data-key') === params.sortType) {
        return item
      }
    })[0];
    let category$ = [...document.querySelectorAll('.category-list__left li')];
    let categoryEl = category$.filter(item => {
      if (item.getAttribute('data-key') === params.category) {
        return item;
      }
    })[0];
    // myTracker.sortSetType(categoryEl.innerText, sortTypeEl.innerText);
    myTracker.send({
      name: 'v5100_测评-访问分类页栏目',
      properties: {
        '栏目': categoryEl.innerText,
        '排序方式': sortTypeEl.innerText
      }
    });
    // APP-测评分类页访问 神策埋点
    appTrackPageView('app_cepingsorting_view')
    // APP-测评分类页-查看分类 神策埋点
    // 因为每个分类页都是单独的链接，所以落地时确认点了哪个分类
    appTrackEvent('app_cepingsorting_checksort', {
      test_sort: categoryEl.innerText,
    })

    return Stream.fromPromise(getSortData(params)).pardonError();
  // return Stream.ajax(APIS.getSort, params).pardonError(err => console.error(err.msg || err), false);
  })
  .pardonError()
  .addListener({
    next (json) {
    },
    error: err => console.error(err)
  });

async function catagoryPage () {
  const e = function(sel) {
    return document.querySelector(sel)
  }
  // URL附带参数
  let requiredParams = await getRequireParams();

  myTracker.setGlobalParams({
    globalParams: {
      '渠道ID': requiredParams.channelId,
      '渠道': channelMap.map[requiredParams.channelId]
    }
  });
  // myTracker.pageView('分类列表页');
  myTracker.send({name: 'v5100_测评_访问分类列表页'});

  if (isAPP) {
    let myBridge = new Bridge({
      methods: [{
        method: 'topFuncBtn',
        callback: (option) => {
          if (option.name === 'testOrderManager') {
            // 分类页前往个人中心的地址，加isCp
            let url = '';
            if (requiredParams.userKey || requiredParams.userId) {
              // 有登陆参数，去测试管理页面
              url = `https://ce${APIS.env}.xinli001.com/cp-m/index.html#/manage/0?userId=${requiredParams.userId}&openId=${requiredParams.openId}&unionId=&userKey=${requiredParams.userKey}&channelId=${requiredParams.channelId}&isCp=1`
            } else {
              // 没有登录参数，直接打开登录页
              // 安卓openwebView会对URL进行一次decode，所以为了保持url的参数去到openWebView窗口仍然是encode状态，所以要进行2次encode
              let redirectBackUrl = encodeURIComponent(encodeURIComponent(location.href));

              url = `https://m${APIS.env}.xinli001.com/account/login-for-ceping?callbackUrl=${redirectBackUrl}&referer=${redirectBackUrl}`;
              console.log('redirectBackUrl', redirectBackUrl);
            }
            jumpMethods.openUrl(url);

            // this.$router.push({
            //     name: 'user',
            //     query: this.$router.query
            // });
          }
        }
      }]
    });
    myBridge.call('topFuncBtnConfig', {
      btnList: [{
        visible: 1,
        name: 'testOrderManager',
        showName: '测试管理'
      }]
    });

    // if (platform.isCeShiApp) {
    //     document.querySelector('.topbar').remove();
    // }
    xinliceshiApp.removeTopbar();
  }

  $assessmentList.addEventListener('click', (e) => {
    let liEle = dom.closest(e.target, 'li');
    if (liEle) {
      let type = liEle.getAttribute('data-type');
      if (type === 'scale') {
        let params = Object.assign(requiredParams, {
          scaleId: liEle.getAttribute('data-id'),
        })
        if (isAliMp || isMeiTuanMp) {
          params.token = GetQueryString('token') || ''
        }
        jumpMethods.goToProTestPage(params);
      } else if (type === 'free') {
        jumpMethods.goToFunTestPage(Object.assign(requiredParams, {
          scaleId: liEle.getAttribute('data-id')
        }));
      }
    }
  })
  /* 前端模拟加载更多 */
  loadMore$.throttleTime(300).filter(res => {
    // console.log('---scroll happened---')

    let all$li = [...$assessmentList.querySelectorAll('li')];
    let last$li = all$li[all$li.length - 1];
    let edgeSmallEnough = last$li ? (Math.abs(document.body.clientHeight - last$li.getBoundingClientRect().bottom) < 180) : false;
    // console.log(document.body.clientHeight, last$li ? last$li.getBoundingClientRect().bottom : 0, edgeSmallEnough)
    // 下一页的数据，下一页大于0才放它过去
    if (needLoadMore) {
      // console.log(edgeSmallEnough);
      return !listLoading && !listEnd && edgeSmallEnough;
    } else {
      // console.log(`检查: ${pageSize * (pageNum)}${-(pageSize * (pageNum + 1))}`)
      let newPageList = $assessmentListData.slice(pageSize * (pageNum), (pageSize * (pageNum + 1)));

      // console.log(`---下一页数据${(newPageList.length > 0)}---`)
      // console.log(`---边距检测${edgeSmallEnough}---`)

      return edgeSmallEnough && (newPageList.length > 0)
    }
  }).addListener({
    next (res) {
      loadingTipEl.classList.add('show');
      console.log('--- loadmore ---')
      if (needLoadMore) {
        getSortData(Object.assign(outSideParams, {
          'pageVo.page': pageNum * 1 + 1
        })).then(() => {
          loadingTipEl.classList.remove('show');
        });
      } else {
        let newPageList = $assessmentListData.slice(pageSize * (pageNum), (pageSize * (pageNum + 1)));
        console.log(newPageList.length);
        if ((newPageList.length < pageSize) && !listEnd) {
          $assessmentList.innerHTML = $assessmentList.innerHTML + newPageList.map(renderItem).join('') + `<p class="end">已全部展示</p>`;
          listEnd = true;
        } else {
          $assessmentList.innerHTML = $assessmentList.innerHTML + newPageList.map(renderItem).join('');
        }
        pageNum = pageNum + 1;
        loadingTipEl.classList.remove('show');
      }
    }
  })
  /* toggle排序菜单的可见性 */
  var visible = false;

  $sortName.addEventListener('click', function (e) {
    visible = !visible;
    $sectionHandlerDropdown.style.display = visible ? '' : 'none';
    visible ? updateDropdownHeight() : resetDropdownHeight();

    e.stopPropagation();
  });

  $categoryList.addEventListener('click', function (e) {
    console.log('--- $categoryList click --- 显示排序菜单 visible', visible)
    if (visible !== false) {
      visible = false;
      $sectionHandlerDropdown.style.display = 'none';
      resetDropdownHeight();
    }
    e.stopPropagation();
  })

  document.querySelector('.section-handler__dropdown').addEventListener('click', function (e) {
    if (visible !== false) {
      visible = false;
      $sectionHandlerDropdown.style.display = 'none';
      resetDropdownHeight();
    }
  })

  // 获取初始化列表
  let category$li = [...$categoryList.querySelectorAll('.s-tabcell')];
  let match$li = category$li.filter(item => {
    return item.getAttribute('data-key') === category
  });
  if (match$li.length > 0) {
    match$li[0].click();
  }

  // 给按时间添加样式
  document.querySelectorAll('.section-handler__dropdown-item ')[0].classList.add('section-handler__dropdown-item--hover')
  // document.querySelector('title').innerText = '测试';

  // 双十二会员弹窗
  function appendVipHtml() {
    let html = `
      <div class="cp-vip-toast" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
        <img class="vip-toast memberLogo-1 show" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/5eff301d931d47949c2136b4021092a4.png">
        <img class="vip-toast memberLogo-2" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/dfed4bf888f641219a9bfe3f812e62f9.png">
        <img class="vip-toast logo1-1" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/f6a246e118ef41819defc0200e855fb5.png">
        <img class="vip-toast logo1-2" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/5c1ca5c5eb4c4df8a67296cc8499d5ce.png">
        <img class="vip-toast logo2-1" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/a943b36e23c44bd6a5712ba93233f388.png">
        <img class="vip-toast logo2-2" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/f2faa7c48fb543e5bff9db85ec777bf0.png">
        <img class="vip-toast logo3-1" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/ead6c4e4036a4d8db83832f6be7c01ec.png">
        <img class="vip-toast logo3-2" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/e0dd83fc97c64864a039fda478a6e51f.png">
      </div>
    `
    document.body.insertAdjacentHTML('beforeend', html)
  }
  function ACTIVITYSLASTYPE() {
    let beginData1 = new Date('2019/12/29 00:00').getTime()
    let beginData2 = new Date('2019/12/30 00:00').getTime()
    let beginData3 = new Date('2019/12/31 00:00').getTime()
    let END_TIME = new Date('2020/1/1 00:00').getTime()
    let newData = new Date().getTime()
    if (newData > END_TIME) {
      return -1
    } else if (newData > beginData3) {
      return 1
    } else if (newData > beginData2) {
      return 2
    } else if (newData > beginData1) {
      return 3
    } else {
      return 0
    }
  }
  function toggleImg(activityType, showType) {
    if (activityType < 0) {
      return
    }
    let o = {
      0: '.memberLogo-',
      1: '.logo1-',
      2: '.logo2-',
      3: '.logo3-'
    }
    let activityClass = `${o[activityType]}${showType}`
    let father = document.querySelector('.cp-vip-toast')
    father.querySelector('.show').classList.remove('show')
    father.querySelector(activityClass).classList.add('show')
  }
  function toggleShow(type) {
    // 判断第几张图片
    let showType = type ? 1 : 2
    // 判断时间范围
    let activityType = ACTIVITYSLASTYPE()
    toggleImg(activityType, showType)
    // 活动时间范围内自动切换
    if (activityType > -1) {
      let timer = setTimeout(() => {
        toggleShow(!type);
        clearTimeout(timer);
      }, 200);
    } else {
      document.querySelector('.cp-vip-toast').style.display = 'none'
    }
  }
  function doubleTwelveVipToast(requiredParams) {
    let activityType = ACTIVITYSLASTYPE()
    if (activityType < 0) {
      return
    }
    // 插入弹窗html
    appendVipHtml()
    // 切换显示图片
    toggleShow()
    let father = document.querySelector('.cp-vip-toast')
    father.addEventListener('click', function () {
      myTracker.send({
        name: '测评-页面交互',
        properties: {
          '会员活动入口': '分类页浮标'
        }
      })
      let userKey = requiredParams.userKey ? requiredParams.userKey : ''
      // let targetUrl = `${location.protocol}//static${APIS.env}.xinli001.com/cp-m/index.html?isCp=1#/memberActivty?sourceFlag=mobile&sourceFlag=mobile&channelId=${requiredParams.channelId}&userKey=${userKey}`
      let targetUrl = `https://static${APIS.env !== '' ? APIS.env : ''}.xinli001.com/cp/index.html?init=26#/vip4Detail?channelId=${requiredParams.channelId}&userKey=${userKey}`
      window.userleft = true
      window.location.href = targetUrl
    })
  }
  // 双十二会员弹窗
  doubleTwelveVipToast(requiredParams)
}
window.userleft = false
catagoryPage();



// WEBPACK FOOTER //
// ./src/entry/category/index.js